import React from 'react';
import { EmailDomain, VerificationStatus } from "nekst-api";
import { useShowContextRequired, Text } from "ui-builder";

import styles from './VerificationStatusField.module.scss';


export default function VerificationStatusField(props: {
  label: string,
  source: string,
}) {
  const showContext = useShowContextRequired<EmailDomain>();

  const status = showContext.data!.status;

  let style: string | undefined;

  if (status === VerificationStatus.PENDING) {
    style = styles.pending;
  } else if (status === VerificationStatus.VERIFIED) {
    style = styles.verified;
  } else if (status === VerificationStatus.REJECTED) {
    style = styles.rejected;
  }

  return <Text className={style}>{status}</Text>;
}
